<template>
    <teleport to="body">
        <AddReportModal
          @closeReportForm="closeReportForm"
          :showEndWorkingDayModal="showEndWorkingDayModal"
        />
      </teleport>
      <teleport to="body">
      <AddPinModal
          @closeAddModal="closePinModal"
          @refreshPins="getPins"
          :showModal="isAddingPin"
      />
    </teleport>
    <div class="lang-wrap">
      <LanguageSwitcher />
    </div>
    <div auto-close="outside" class="dropdown notification-wrapper-general"  variant="nav-item"   ref="isOpen">
        <div @click="openReport">
          <CIcon size="xl" icon="cilCalendarCheck" class="report-icon" />
        </div>
<!-- pin -->
      <CDropdown class="pin-dropdown" variant="nav-item">
        <CDropdownToggle placement="bottom" class="py-0" :caret="false">
          <img
            src="@/assets/icons/pin.svg"
            alt="Pin Icon"
            class="report-icon"
            style="height: 24px; margin-right: 20px;"
          />
        </CDropdownToggle>

        <CDropdownMenu class="pins-menu">
          <div class="pins-menu-wrapper" v-if="pins.length">
            <CDropdownItem class="pin-item" v-for="item in pins" :key="item.id">
            <div class="pin-item-name"> 
              <a v-c-tooltip="{ content: $t('pins.sameTab'), placement: 'top' }" :href="item.url">{{ item.name }}</a> 
              <a target="_blank" :href="item.url"><img src="@/assets/icons/new_window.svg "  v-c-tooltip="{ content: $t('pins.newTab'), placement: 'top' }"/></a> 
            </div> 
            <span @click="deletePin(item.id)" class="pin-close">x</span>
          </CDropdownItem>
          </div>
          <div class="pins-menu-wrapper" v-else>
            <CDropdownItem class="pin-item" >
              <span class="no-pins">{{ $t('pins.noPin') }}</span> 
          </CDropdownItem>
          </div>
          <CDropdownItem v-if="!isAddingPin" @click="isAddingPin = true">
            + {{ $t('pins.addPin') }}
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>


<!-- notifications -->
        <div style="margin-right: 20px;"
            ref="ignoreElRef"
            @click="dropVisiable = !dropVisiable"
            placement="bottom-end"
            class="py-0 dropdown-wrapper"
            :caret="false">
                <CIcon icon="cil-bell" class="dropdown-icon"  />
                <div v-if="allNotifications.unchecked_count > 0" class="dropdown-count">
                   <p>{{ allNotifications.unchecked_count  }}</p>
                </div>
        </div>


        <div v-show="dropVisiable"  class="notification-wrapper" ref="target">
            <template v-if="!isNotificationsEmpty">
                <div class="nav-wrapper">
                    <div class="nav-btns">
                        <CButton
                            @click.stop="checkAllNotifications"
                            color="dark" variant="outline"
                            class="nav-btns-btn">
                            {{ $t('notification.markAll') }}
                        </CButton>
                        <CButton
                            @click.stop="deleteAllNotifications"
                            color="dark" variant="outline"
                            class="nav-btns-btn">
                            {{ $t('notification.clearAll') }}
                        </CButton>
<!--                        <CButton-->
<!--                            color="dark" variant="outline"-->
<!--                            class="nav-btns-btn">-->
<!--                            {{ $t('notification.markAll') }}-->
<!--                        </CButton>-->
<!--                        <CButton-->
<!--                            color="dark" variant="outline"-->
<!--                            class="nav-btns-btn">-->
<!--                            {{ $t('notification.clearAll') }}-->
<!--                        </CButton>-->

                        <CButton
                            color="dark"
                            variant="outline"
                            class="nav-btns-btn"
                            @click="dropVisiable = false; this.$router.push('/notifications')">
                            <img width="20" height="20" src="https://img.icons8.com/ios/50/open-in-popup.png" alt="open-in-popup"/>
                        </CButton>
                    </div>

                </div>
 <!--       mentions-->
                <div class="items-wrapper">
                <template v-if="allNotifications.project_task.length">
                    <CDropdownItem class="title title-projects"> {{ $t('projects.title') }} 🧑‍💻 </CDropdownItem>

                    <CDropdownItem
                        v-for="(item, idx) in allNotifications.project_task"
                        :key="idx"
                        class="dropdown-item item"

                    >
                        <div v-if="item.notification_name === 'new_project_user'" class="notification-item">
                            <div  class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="checkNotification(item)">
                                <p>{{item.additional_data.user_name}}  {{ $t(`notification.${item.notification_name}`) }} "{{item.model.name}}"</p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>
                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                        <div v-if="item.notification_name === 'new_task_user'" class="notification-item">
                            <div  class="notification-text"
                                  :class="{'notification-text-checked': item.is_checked}"
                                  @click="checkNotification(item)">
                                <p>{{item.additional_data.user_name}}  {{ $t(`notification.${item.notification_name}`) }} "{{item.model.name}}"</p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>
                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                        <div v-if="item.notification_name === 'task_status_changed'" class="notification-item">
                            <div  class="notification-text"
                                  :class="{'notification-text-checked': item.is_checked}"
                                  @click="checkNotification(item)">
                                <p> {{ $t(`notification.status_of`) }} "{{item.model.name }}" {{ $t(`notification.${item.notification_name}`) }} "{{$t(`projects.kanban.${item.additional_data.status}`)}}"</p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>
                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                        <div v-if="item.notification_name === 'new_task_comment'" class="notification-item">
                            <div  class="notification-text"
                                  :class="{'notification-text-checked': item.is_checked}"
                                  @click="checkNotification(item)">
                                <p> {{ $t(`notification.${item.notification_name}`) }} {{item.model.user.user_name}} {{ $t(`notification.at_task`) }} "{{item.model.task.name}}"</p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>
                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                        <div v-if="item.notification_name === 'new_task_comment_mention'" class="notification-item">
                            <div  class="notification-text"
                                  :class="{'notification-text-checked': item.is_checked}"
                                  @click="checkNotification(item)">
                                <p>{{ item.model.user.user_name ?  item.model.user.user_name : ''}} {{ $t(`notification.${item.notification_name}`) }} "{{item.model && item.model.task && item.model.task.name ? item.model.task.name : ''}}"</p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>
                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>
                    </CDropdownItem>
                </template>
<!--    birthdays-->
                <template v-if="allNotifications.birthday.length">
                    <CDropdownItem class="title title-b-day">{{$t('birthday.title')}} 🎂 </CDropdownItem>

                    <CDropdownItem
                        v-for="(item, idx) in allNotifications.birthday"
                        :key="idx"
                        class="dropdown-item item"

                    >
                        <div class="notification-item">
                            <div class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="showEvent(item, 'birthday!')">
                                <p>
                                    {{ item.model.user_name }} {{ $t('notification.hasBirthday') }} {{ formattedBirthday(item.model.birthday) }}  ({{ formatDaysLeft(item.model.birthday) }})
                                </p>
                            </div>
                           <div class="notification-remove">
                               <div v-if="delLoading === item.id" class="loading-wrapper">
                                   <LoaderMini></LoaderMini>
                               </div>

                               <p v-else @click.stop="delNotification(item.id)">
                                   X
                               </p>
                           </div>
                        </div>
                    </CDropdownItem>
                </template>
<!--vacations-->
                <template
                    v-if="allNotifications.approved_vacation.length"
                >
                    <CDropdownItem class="dropdown-item title title-vacations">{{
                            $t('general.vacations_daysOff')
                        }} 📅</CDropdownItem>

                    <CDropdownItem
                        v-for="item in allNotifications.approved_vacation"
                        :key="item.id"
                        class="dropdown-item vacations"
                    >
                        <div class="notification-item">
                            <div class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="showEvent(item, 'vacations')">

                                <p v-if="isDateValid(item.model.start)">
                                    {{ item.model.user.user_name }}
                                    {{ $t(`notification.${item.notification_name}`) }} {{ formattedBirthday(item.model.start) }} {{item.notification_name === 'approved_vacation' ? ' - ' : ''}} {{item.notification_name === 'approved_vacation' ? formattedBirthday(item.model.end) : ''}} ({{  formatDaysLeft(item.model.start) }})
                                </p>

                                <p v-else>
                                {{ item.model.user.user_name }}
                                {{ $t(`notification.${item.notification_name}`) }} {{ formattedBirthday(item.model.start) }} {{item.notification_name === 'approved_vacation' ? ' - ' : ''}} {{item.notification_name === 'approved_vacation' ? formattedBirthday(item.model.end) : ''}}
                                </p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>

                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                    </CDropdownItem>


                </template>
<!--pendingVacations-->
                <template v-if="isAdmin && allNotifications.pending_vacation.length || isHr && allNotifications.pending_vacation.length">
                    <CDropdownItem class="title title-requests">{{ $t('general.requests') }} ❓</CDropdownItem>
                    <CDropdownItem
                        v-for="item in allNotifications.pending_vacation"
                        :key="item.id"
                        class="dropdown-item vacations"
                    >
                        <div class="notification-item">
                            <div class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="showEvent(item, 'requests')">
                                <p>
                                    {{ item.model.user.user_name }}
                                    {{ $t(`notification.${item.notification_name}`) }} {{ formattedBirthday(item.model.start) }} - {{ formattedBirthday(item.model.end) }}
                                </p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>

                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                    </CDropdownItem>
                </template>
<!--close candidate meetings-->
                <template v-if="isAdmin && allNotifications.candidate.length || isHr && allNotifications.candidate.length">
                    <CDropdownItem class="title title-candidates">{{ $t('hr.pageTitle') }} 🙋‍♂️</CDropdownItem>

                    <CDropdownItem
                        v-for="item in allNotifications.candidate"
                        :key="item.id"
                        class="dropdown-item vacations"
                    >
                        <div class="notification-item">
                            <div class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="showEvent(item, 'candidates')">
                                <p>

                                    {{ $t(`notification.${item.notification_name}`) }} {{ item.model.first_name }} {{ item.model.last_name }}   {{ formatCandidate(item.model.start) }}
                                </p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>

                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                    </CDropdownItem>
                </template>
<!--one-to-one-->
                <template v-if="isAdmin && allNotifications.event.length || isHr && allNotifications.event.length">
                    <CDropdownItem class="title title-onetoone">{{ $t('sidebar.oneToOne') }} 👥</CDropdownItem>

                    <CDropdownItem
                        v-for="item in allNotifications.event"
                        :key="item.id"
                        class="dropdown-item vacations"
                    >
                        <div class="notification-item">
                            <div class="notification-text"
                                 :class="{'notification-text-checked': item.is_checked}"
                                 @click="showEvent(item, 'onetoone')">
                                <p>

                                    {{ $t(`notification.${item.notification_name}`) }} {{ item.model.client.user_name }}    {{ formatCandidate(item.model.start) }}
                                </p>
                            </div>
                            <div class="notification-remove">
                                <div v-if="delLoading === item.id" class="loading-wrapper">
                                    <LoaderMini></LoaderMini>
                                </div>

                                <p v-else @click.stop="delNotification(item.id)">
                                    X
                                </p>
                            </div>
                        </div>

                    </CDropdownItem>
                </template>
                </div>
            </template>

            <template v-else>
                <div class="empty-notifications">{{ $t('notification.noActualInfo') }}</div></template>
        </div>
    </div>

    <CDropdown class="dropdown" variant="nav-item">
        <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
            <div class="avatar">
                <img
                    v-if="!avatar"
                    class="avatar-img"
                    src="@/assets/images/avatars/defaultUser.webp"
                    alt="user"
                />
                <img
                    v-else
                    class="avatar-img profile-avatar"
                    :src="avatar"
                    alt="user"
                />
            </div>

            {{ nickname }}
        </CDropdownToggle>
        <CDropdownMenu>
            <router-link :to="`/profile/${nickname}`">
                <CDropdownItem class="dropdown-item">
                    <CIcon icon="cil-calendar" /> {{ $t('base.myProfile') }}
                </CDropdownItem>
            </router-link>


            <CDropdownItem @click="getVacation" class="dropdown-item">
                <CIcon icon="cil-notes" /> {{ $t('base.getVacation') }}
            </CDropdownItem>

            <CDropdownItem @click="getDayOff" class="dropdown-item">
                <CIcon icon="cil-notes" /> {{ $t('base.getDayOff') }}
            </CDropdownItem>

            <CDropdownItem @click="getSickLeave" class="dropdown-item">
                <CIcon icon="cil-notes" /> {{ $t('base.getSickDay') }}
            </CDropdownItem>

            <router-link to="/logout">
                <CDropdownItem @click="logout" class="dropdown-item">
                    <CIcon icon="cil-lock-locked" /> {{ $t('base.logout') }}
                </CDropdownItem>
            </router-link>
        </CDropdownMenu>
    </CDropdown>


    <Teleport to="body">
<!--        birthday-->
        <CModal
            size="xl"
            alignment="center"
            :visible="eventType === 'birthday!'"
            @close="closeEventModal">

            <CModalHeader>
                <p><strong>  {{  $t(`general.${eventType}`) }} 🎂 </strong></p>
            </CModalHeader>
            <CModalBody>
                <p><a class="user-lnk" :href="`/profile/${items.model.user_name}`" target="_blank">{{ items.model.user_name }}</a> {{ $t('notification.hasBirthday') }} {{ formattedBirthday(items.model.birthday) }}!  ({{ formatDaysLeft(items.model.birthday) }})</p>
                <p>{{$t('notification.yearsOld') + ' ' + calculateAge(items.model.birthday)}}. {{$t('notification.dontForget')}}🥳</p>

            </CModalBody>
            <CModalFooter>
                <CButton v-if="isHr || isAdmin"
                    color="primary"
                    size="sm"
                    @click="relinkToCalendar"
                >
                    {{  $t(`notification.seeInCalendar`) }}
                </CButton>

                <CButton
                    color="primary"
                    size="sm"
                    @click="closeEventModal"
                >
                    OK
                </CButton>
            </CModalFooter>
        </CModal>



        <!--        vacations-->
        <CModal
            size="xl"
            alignment="center"
            :visible="eventType === 'vacations'"
            @close="closeEventModal">

            <CModalHeader>
                <p><strong>  {{  $t(`notification.${eventType}`) }} 📅 </strong></p>
            </CModalHeader>
            <CModalBody>
                <p>{{ items.model.user.user_name }} {{ $t(`notification.${items.notification_name}`) }} {{ formattedBirthday(items.model.date) }} ({{ formatDaysLeft(items.model.date) }})</p>

            </CModalBody>
            <CModalFooter>
                <CButton v-if="isHr || isAdmin"
                         color="primary"
                         size="sm"
                         @click="relinkToVacations"
                >
                    {{  $t(`notification.seeInCalendar`) }}
                </CButton>

                <CButton
                    color="primary"
                    size="sm"
                    @click="closeEventModal"
                >
                    OK
                </CButton>
            </CModalFooter>
        </CModal>

        <!--        requests-->
        <CModal
            size="xl"
            alignment="center"
            :visible="eventType === 'requests'"
            @close="closeEventModal">

            <CModalHeader>
                <p><strong>  {{  $t(`notification.${eventType}`) }} ❓ </strong></p>
            </CModalHeader>
            <CModalBody>
                <p>{{ items.model.user.user_name }} {{ $t(`notification.${items.notification_name}`) }} {{ formattedBirthday(items.model.start) }}</p>

            </CModalBody>
            <CModalFooter>
                <CButton v-if="isHr || isAdmin"
                         color="primary"
                         size="sm"
                         @click="relinkToVacations"
                >
                    {{  $t(`notification.seeInCalendar`) }}
                </CButton>

                <CButton
                    color="primary"
                    size="sm"
                    @click="closeEventModal"
                >
                    OK
                </CButton>
            </CModalFooter>
        </CModal>

<!--        candidates-->
        <CModal
            size="xl"
            alignment="center"
            :visible="eventType === 'candidates'"
            @close="closeEventModal">

            <CModalHeader>
                <p><strong>  {{  $t(`notification.${eventType}`) }} 🙋‍♂ </strong></p>
            </CModalHeader>
            <CModalBody>
                <p> {{ $t(`notification.${items.notification_name}`) }} {{ items.model.first_name }} {{ items.model.last_name }}   {{ formatCandidate(items.model.start) }}</p>

            </CModalBody>
            <CModalFooter>
                <CButton v-if="isHr || isAdmin"
                         color="primary"
                         size="sm"
                         @click="relinkToCandidates"
                >
                    {{  $t(`notification.seeInCalendar`) }}
                </CButton>

                <CButton
                    color="primary"
                    size="sm"
                    @click="closeEventModal"
                >
                    OK
                </CButton>
            </CModalFooter>
        </CModal>

<!--one to one-->
        <CModal
            size="xl"
            alignment="center"
            :visible="eventType === 'onetoone'"
            @close="closeEventModal">

            <CModalHeader>
                <p><strong>  {{  $t(`notification.${eventType}`) }} 👥 </strong></p>
            </CModalHeader>
            <CModalBody>
                <p>

                    {{ $t(`notification.${items.notification_name}`) }} {{ items.model.client.user_name }}    {{ formatCandidate(items.model.start) }}
                </p>

            </CModalBody>
            <CModalFooter>
                <CButton v-if="isHr || isAdmin"
                         color="primary"
                         size="sm"
                         @click="relinkToOneToOne"
                >
                    {{  $t(`notification.seeInCalendar`) }}
                </CButton>

                <CButton
                    color="primary"
                    size="sm"
                    @click="closeEventModal"
                >
                    OK
                </CButton>
            </CModalFooter>
        </CModal>
    </Teleport>
    <Teleport to="body">
        <CModal
            size="xl"
            alignment="center"
            :visible="sickVisiable"
            @close="sickVisiable = false; this.showWPwarn = false; this.sickVisiable = false; this.sickLeaveForm = { start: null, end: null, withOutPay: false}">

            <CModalHeader>
                <CModalTitle>{{ $t('base.getSickDay') }}</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div class="days-count">
                    {{ $t('profile.usedDays') }}: {{getVacationsCount.sick_day.used_count}} / {{getVacationsCount.sick_day.max_count}}
                </div>
                <div v-if="getVacationsCount.sick_day.used_count >= getVacationsCount.sick_day.max_count" class="days-count-warn">
                    {{ $t('profile.sickWarning') }}
                </div>
                <CFormLabel>{{ $t('calendar.form.dateBeginning') }}</CFormLabel>
                <br>
<!--                <input v-model="sickLeaveForm.start" class="sickInput" type="date" :min="getTodayDate()"/>-->
                <Datepicker
                    ref="date"
                    :min-date="new Date()"
                    v-model="sickLeaveForm.start"
                    :disabled-week-days="[6,0]"
                    :highlight-week-days="[6, 0]"
                    :enable-time-picker="false"
                    teleport-center
                ></Datepicker>
                <br>
                <CFormLabel>{{ $t('calendar.form.dateEnding') }}</CFormLabel>
                <br>
<!--                <input v-model="sickLeaveForm.end" class="sickInput" type="date" :min="sickLeaveForm.start"/>-->
                <Datepicker
                    ref="date"
                    :min-date="sickLeaveForm.start"
                    v-model="sickLeaveForm.end"
                    :disabled-week-days="[6,0]"
                    :highlight-week-days="[6, 0]"
                    :enable-time-picker="false"
                    teleport-center
                ></Datepicker>


                <small
                    v-if="sickError"
                    class="helper-text invalid"
                >{{ $t('calendar.form.dateValidation') }}</small
                >
                <div class="days-count-warn" v-if="showWPwarn">
                    {{ $t('profile.WPsickwarn') }}
                </div>
                <CFormCheck id="flexCheckDefaultVModel" class="checkbox-pay" :label="$t('hr.withoutPay')" v-model="sickLeaveForm.withOutPay" />

            </CModalBody>
            <CModalFooter>

                <CButton
                    color="secondary"
                    size="sm"
                    @click="sickVisiable = false; this.showWPwarn = false; this.sickVisiable = false; this.sickLeaveForm = { start: null, end: null, withOutPay: false}"
                >
                    {{  $t(`general.close`) }}
                </CButton>
                <CButton
                    color="primary"
                    size="sm"
                    @click="getAsickLeave"
                >
                    {{  $t(`general.confirm`) }}
                </CButton>
            </CModalFooter>
        </CModal>
    </Teleport>
</template>

<script>
/* eslint-disable */
import LanguageSwitcher from '@/components/base/LanguageSwitcher.vue'
import {reactive, toRefs, computed, ref} from 'vue'
import { useStore } from 'vuex'
import LoaderMini from "@/components/hr/LoaderMini.vue";
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Datepicker from "@vuepic/vue-datepicker";
import fireSwal from "@/helpers/fireSwal";
import {onClickOutside} from "@vueuse/core/index";
import AddReportModal from '@/components/dashboard/AddReportModal.vue'
import AddPinModal from '../dashboard/AddPinModal.vue';
// import { state, socket } from "@/socket";


export default {
    name: 'AppHeaderDropdownAccnt',
    emits: ['getVacation', 'getDayOff', 'showEvent'],
    components: {
        Datepicker,
        LoaderMini,
        LanguageSwitcher,
        AddReportModal,
        AddPinModal,
    },
    setup() {
        const isOpen = ref(false)
        const target = ref(null)
        const ignoreElRef = ref()
        let dropVisiable = ref(false)
        onClickOutside(target, (el) => {
            if (target.value && !target.value.contains(el.target) &&
                !el.target.closest('.dropdown-wrapper')) {
                dropVisiable.value = false;
            }
        })
        const toggle = () => {

        }
        const store = useStore()
        const state = reactive({
            closeBirthdaysNotifications: [],
            nickname: computed(
                () => store.getters['authorization/getUserNickname'],
            ),
            avatar: computed(
                () => store.getters['authorization/getUserAvatar'],
            ),
            daysOff: computed(() =>
                store.getters['hr/getDaysOffCalendar'].filter(
                    (item) => item.active === 'pending',
                ),
            ),
            vacations: computed(() =>
                store.getters['hr/getVacationsCalendar'].filter(
                    (item) => item.active === 'pending',
                ),
            ),
            closeVacations: computed(
                () => store.getters['events/getCloseVacations'],
            ),
            closeDaysOff: computed(
                () => store.getters['events/getCloseDaysOff'],
            ),
            closeBirthdays: computed(
                () => store.getters['users/getCloseBirthdays'],
            ),
            closeMeetings: computed(() => store.getters['hr/getCloseMeetings']),
            closeCandidateMeetings: computed(
                () => store.getters['hr/getCloseCandidateMeetings'],
            ),
            hrRole: computed(() => store.getters['authorization/getHrState']),
        })

        return { ...toRefs(state), target, dropVisiable, ignoreElRef,  store,  isOpen,
            toggle }
    },

    data() {
        return {
            isAddingPin: false,
            pins: [],
            showPin: false,
            showEndWorkingDayModal: false,
            showWPwarn: false,
            sickError: false,
            sickLeaveForm: {
              start: null,
              end: null,
              withOutPay: false,
            },
            sickVisiable: false,
            // dropVisiable: false,
            isVisiable: false,
            options: {
                broadcaster: 'pusher',
                key: '6a36364ae74d1f099b6f'
            },
            delLoading: false,
            allNotifications: {
                approved_vacation: [],
                birthday: [],
                candidate: [],
                event: [],
                pending_vacation: [],
                project_task: []
            },
            eventType: '',
            items: {
                birthday: {}
            }
        }
    },


    created() {
        this.$store.dispatch('notifications/getAllNotifications').then(() => {
            this.allNotifications = this.getAllNotifications
        })

        this.$store.dispatch('hr/getVacationsCount', this.$store.getters['authorization/getCurrentUser'].id).then(() => {
        })

        this.getPins()
    },
    mounted() {
        this.$store.dispatch('users/getCloseBirthdays').then(() => {
            this.closeBirthdaysNotifications = this.closeBirthdays.map(
                (item) => {
                    const dayCount = Math.floor(
                        Math.abs(
                            new Date().getTime() -
                                new Date(item.birthday).getTime(),
                        ) /
                            (1000 * 3600 * 24),
                    )

                    const dayTranslate =
                        dayCount === 1
                            ? 'notification.daysOne'
                            : dayCount < 5
                            ? 'notification.daysTwo'
                            : 'notification.days'

                    return {
                        birthday: item.birthday,
                        date: item.shortDate,
                        age: item.age,
                        user: item.user,
                        notification: `${item.user} ${this.$t(
                            'birthday.celebratesBirthday',
                        )}`,
                        dayTranslate: dayTranslate,
                        dayCount: dayCount,
                    }
                },
            )

//SOCKET IO
                window.Pusher = Pusher;
                const userId = this.$store.getters['authorization/getCurrentUser'].id;

                const echo = new Echo({
                    broadcaster: 'pusher',
                    key: '6a36364ae74d1f099b6f',
                    cluster: 'eu',
                });

                echo.channel(`users.${userId}`)
                    .listen('.notifications.created', () => {
                        this.renewNotifications()
                    });



                // window.Echo = new Echo({
                //     ...this.options,
                //     client: new Pusher(this.options.key, this.options)
                // });
        }

        )

        // this.$store.dispatch('hr/getCloseMeetings', this.currentUser.id)
        //
        // this.$store.dispatch('events/getCloseVacations', this.currentUser.id)
        //
        // this.$store.dispatch('events/getCloseDaysOff', this.currentUser.id)

        // this.$store.dispatch('hr/getCloseCandidateMeetings', {
        //     amount: '1000',
        //     authorId: this.currentUser.id,
        // }).then(()=>{
        //     console.log('from AppHeaderDropdownAccnt')})
    },
    methods: {
      async deletePin(id) {
        const self = this;
        this.$store
        .dispatch('notifications/delPin', {
          id: id
        })
        .then(() => {
          this.getPins();
          fireSwal(this.$t('pins.pinDeleted'), 'success')
        })
        .catch((err) => {
          console.log(err)
        })
      },

      closePinModal() {
        this.isAddingPin = false
        this.isAddingPin = false
      },

      async getPins() {
        this.$store.dispatch('notifications/getPins').then((resp) => {
           this.pins = resp.data.data
        })
      },

      async openPin() {
          this.showPin = true
      }, 



      async openReport() {
        if (this.beginDayState) {
          this.showEndWorkingDayModal = true
        } else {
          this.$store.dispatch('reports/beginWorkingDay').then(() => {
            this.showEndWorkingDayModal = true
          })
        }
      },

      closeReportForm() {
        this.showEndWorkingDayModal = false
      },
        getAsickLeave() {
            if(!this.sickLeaveForm.start || !this.sickLeaveForm.end) {
                this.sickError = true
            } else if ((this.getVacationsCount.sick_day.used_count >= this.getVacationsCount.sick_day.max_count) && !this.sickLeaveForm.withOutPay) {
                this.showWPwarn = true
                return
            } else

            {
                this.sickError = false
                this.$store
                    .dispatch(`hr/addSickLeave`, {
                        form: {
                            start: this.sickLeaveForm.start,
                            end: this.sickLeaveForm.end,
                            user_id: this.currentUser.id,
                            // active: 'pending',
                            without_pay: this.sickLeaveForm.withOutPay,
                        },
                        id: this.currentUser.id,
                    }).then(() => {
                        this.showWPwarn = false
                        this.sickVisiable = false
                        this.sickLeaveForm = {
                        start: null,
                        end: null,
                        withOutPay: false,
                    },
                    fireSwal(
                        this.$t(
                            `notification.sickdayIsRequested`,
                        ),
                        'success',
                    )
                })
                    .catch((error) => {
                        console.log(error)
                        if (error.response.status === 422) {
                            fireSwal(
                                this.$t(
                                    `notification.taken`,
                                ),
                                'error',
                            )
                        }
                    })
            }

        },

        formatDateForServer(inputDate) {
            const date = new Date(inputDate);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}-${month}-${year}`;
        },

        getTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        isDateValid(date) {
            const inputDate = new Date(date);
            const today = new Date();
            return inputDate >= today;
        },
        dateFormatt(dateString) {
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour12: false
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('ua-UA', options);

        },

    calculateAge(birthday) {
        const birthDate = new Date(birthday);
        const currentDate = new Date();

        const age = currentDate.getFullYear() - birthDate.getFullYear();

        if (
            currentDate.getMonth() < birthDate.getMonth() ||
            (currentDate.getMonth() === birthDate.getMonth() &&
                currentDate.getDate() < birthDate.getDate())
        ) {
            return age ;
        }

        return age;
},

        renewNotifications() {
            this.$store.dispatch('notifications/getAllNotifications').then(() => {
                this.allNotifications = this.getAllNotifications
            })
        },

        checkAllNotifications() {
            this.$store.dispatch('notifications/checkAllNotifications')
                .then(() => {
                    this.renewNotifications()
                    }
                )
        },

        deleteAllNotifications() {
            this.$store.dispatch('notifications/deleteAllNotifications')
                .then(() => {
                        this.renewNotifications()
                    }
                )
        },

        daysLeft(birthday) {
            if (birthday) {
                const today = new Date();
                const birthDate = new Date(birthday);
                birthDate.setFullYear(today.getFullYear());
                const timeDiff = birthDate - today;
                const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
                return daysLeft >= 0 ? daysLeft : 365 + daysLeft;
            }
            return '?';
        },
        formatDaysLeft(birthday) {
            const daysLeftValue = this.daysLeft(birthday);
            if (daysLeftValue === 0) {
                return `${this.$t('notification.today!')}`;
            } else if (daysLeftValue === 1) {
                return `${daysLeftValue} ${this.$t('notification.dayLeft')}`;
            } else if (daysLeftValue > 1) {
                return `${daysLeftValue} ${this.$t('notification.daysLeft')}`;
            }
        },

        formattedBirthday(birthday) {
            if (birthday) {
                const parts = birthday.split('-');
                if (parts.length === 3) {
                    return `${parts[2]}.${parts[1]}`;
                }
            }
            return birthday;
        },

        formatCandidate(dateTime) {
            if (!dateTime) return '';
            const date = new Date(dateTime);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${day}.${month}  /  ${hours}:${minutes}`;
        },

        delNotification(id) {
            this.delLoading = id
            this.$store.dispatch('notifications/deleteNotification', id)
                .then(() => {
                    this.$store.dispatch('notifications/getAllNotifications').then(() => {
                        this.delLoading = false
                        this.allNotifications = this.getAllNotifications
                    })
                    }
                )
        },

        closeEventModal() {
          this.eventType = ''
            this.items = {}
        },

        relinkToCalendar() {
            this.closeEventModal()
            this.$router.push('/hr/birthday/general')
        },
        relinkToVacations() {
            this.closeEventModal()
            this.$router.push('/hr/vacations/general')
        },
        relinkToCandidates() {
            this.closeEventModal()
            this.$router.push('/hr/candidates/general')
        },

        relinkToOneToOne() {
            this.closeEventModal()
            this.$router.push('/hr/meetings/general')
        },
        // connect() {
        //     socket.connect();
        // },
        // disconnect() {
        //     socket.disconnect();
        // },
        logout() {
            this.store.dispatch('authorization/logout')
                .then(()=> {
                    localStorage.clear();
                })
        },
        getVacation() {
            this.$emit('getVacation', true)
        },
        getDayOff() {
            this.$emit('getDayOff', true)
        },
        getSickLeave() {
            this.sickVisiable = true
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        showEvent(item, type) {
            this.toggle()
            this.dropVisiable = false
            this.$store.dispatch('notifications/checkNotification', {id: item.id})
                .then(() => {

                        this.$store.dispatch('notifications/getAllNotifications').then(() => {
                            this.allNotifications = this.getAllNotifications
                    })
                })

            this.eventType = type
            this.items = item

        },

        checkNotification(item) {
            this.$store.dispatch('notifications/checkNotification', {id: item.id})
                .then(() => {
                    this.$store.dispatch('notifications/getAllNotifications').then(() => {
                        this.dropVisiable = false
                        this.allNotifications = this.getAllNotifications
                        this.isVisiable = false
                        switch(item.notification_name) {
                            case 'new_task_user':
                            case 'task_status_changed':
                                this.$router.push(`/task/${item.model.tag}`)
                                break;

                            case 'new_project_user':
                                this.$router.push(`/tasks/${item.model.slug}`)
                                break;

                            case 'new_task_comment':
                            case 'new_task_comment_mention':
                                this.$router.push(`/task/${item.model.task.tag}`)
                        }
                    })
                    }
                )
        },

        dateFormat(dateString) {
            const options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            };
            const date = new Date(dateString);
            return date.toLocaleDateString('ua-UA', options);

        },
    },
    computed: {
      beginDayState() {
      return this.$store.getters['reports/getBeginDayStatus']
    },

        getVacationsCount() {
            return this.$store.getters['hr/getVacationsCount']
        },

        isNotificationsEmpty() {
          return !this.allNotifications.approved_vacation.length && !this.allNotifications.birthday.length
              && !this.allNotifications.candidate.length && !this.allNotifications.event.length
              && !this.allNotifications.pending_vacation.length && !this.allNotifications.project_task.length
        },


        getAllNotifications() {
          return this.$store.getters['notifications/getAllNotifications']
        },

        isAdmin() {
            const user = this.$store.getters['authorization/getCurrentUser']
            return user && user.role && user.role.name === 'admin'
        },

        isPm() {
            const user = this.$store.getters['authorization/getCurrentUser']
            return user && user.roles && Array.isArray(user.roles) && user.roles.some((obj => obj && obj.name === "Project manager"))
        },

        isHr() {
            const user = this.$store.getters['authorization/getCurrentUser']
            return user && user.roles && Array.isArray(user.roles) && user.roles.some((obj => obj && obj.name === "HR"))
        },

        // connected() {
        //     return state.connected;
        // },
        notificationCount() {
            return Number(
                this.closeBirthdaysNotifications.length +
                    this.daysOff.length +
                    this.vacations.length +
                    this.closeMeetings.length +
                    this.closeCandidateMeetings.length,
            )
        },
        currentUser() {
            return this.$store.getters['authorization/getCurrentUser']
        },
    },
}
</script>

<style lang="scss" scoped>
.report-icon {
  margin: 0 15px 5px 10px;
  &:hover {
    cursor: pointer;
  }
}
.profile-avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.dropdown {
    display: flex;
    align-items: center;
    @media screen and (max-width: 592px) {
      position: initial;
    }

    &-wrapper {
        cursor: pointer;
        position: relative;
    }

    &-menu {
        padding: 0;
    }

    &-item {
        cursor: pointer;
        font-weight: 700;
        color: #2c384a;
        @media screen and (max-width: 430px) {
            font-size: 12px;
        }
        &:hover {
            background-color: white;
        }
        &-checked {
            font-weight: 400;
        }
    }

    &-icon {
        height: 32px !important;
        width: 24px !important;
    }

    &-count {
        width: 25px;
        height: 25px;
        position: absolute;
        top: -10px;
        right: 0;
        color: white;
        font-size: 10px;
        text-align: center;
        background-color: orangered;
        border-radius: 50%;
        & p {
            margin-top: 5px;
            font-weight: bold;
        }
    }
}



.notification {
    &-wrapper {
        max-width: 40vw;
        position: absolute;
        top: 40px;
        right: 0;
        max-height: 320px;
        overflow-y: scroll;
        background-color: white;
        border: 1px solid lightgrey;
        border-radius: 10px;
        padding-bottom: 5px;
        @media screen and (max-width: 533px) {
            max-width: 95vw;
            right: -20vw;
        }
        @media screen and (max-width: 430px) {
            max-width: 95vw;
            right: -34vw;
        }
        @media screen and (max-width: 390px) {
            max-width: 95vw;
            right: -37vw;
        }
        @media screen and (max-width: 375px) {
            max-width: 95vw;
            right: -39vw;
        }
        @media screen and (max-width: 360px) {
            max-width: 95vw;
            right: -41vw;
        }
        &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
            margin: 5px 5px;
            padding: 5px 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #3C4B64;
            border-radius: 6px;
        }
        &::-webkit-scrollbar-track {
            background-color: white;
            border-bottom-right-radius: 10px;
        }
        @media screen and (max-width: 592px) {

        }

        &-general {
            position: relative;
        }
    }
}

//.birthday {
//    color: #800080;
//    font-weight: bold;
//}

.title {
    padding-left: 10px;
    font-weight: 700;
    background-color: #ebedef;
    &:hover {
        background-color: #ebedef;
    }
    &-b-day {
        color: rgb(192, 4, 195);
    }
    &-vacations {
        color: rgb(71, 179, 0);

    }
    &-requests {
        color: red;
    }

    &-candidates {
        color: rgb(239, 153, 6);
    }

    &-onetoone {
        color: rgb(16, 157, 244);
    }
    &-projects {
        color: rgb(0, 98, 255);
    }

}

.requests {
    color: red;
    font-weight: bold;
}

.vacations {
    color: green;
    font-weight: bold;
}

.candidates {
    color: orange;
    font-weight: bold;
}

.one-to-one {
    color: rgb(0, 132, 255);
    font-weight: bold;
}

.nav {
    &-wrapper {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        min-width: 400px;
        position: sticky;
        top: 0;
        background-color: ghostwhite;
        width: 100%;
        border-bottom: 1px solid lightgray;
            @media screen and (max-width: 430px) {
                min-width: 0;
                max-width: 100%;
            }

    }
    &-btns {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        @media screen and (max-width: 430px) {
            //width: 80%;
        }
        &-btn {
            border: none;
            transition: 0.2s all;
            display: inline-block;
            flex-wrap: nowrap;
            @media screen and (max-width: 430px) {
                font-size: 0.8em;
            }
            &:hover {
                background-color: ghostwhite;
                color: #4f5d73;
                text-decoration: underline;

            }
        }
    }
}

.notification {
    &-item {
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        margin-left: 10px;
        transition: all 0.2s;
        border-radius: 15px;
        margin-bottom: 5px;
        @media screen and (max-width: 430px) {
            //position: relative;
        }
        &:hover {
            background-color: lightblue;
        }
    }
    &-text {
        max-width: 35vw;
        overflow-x: hidden;
        margin-right: 10px;
        color: rgba(0, 0, 21, 0.65);
        &::after {
            @media screen and (max-width: 430px) {
                //position: absolute;
                //content: '...';
                //right: 45px;
                //top: 0px;
            }

        }
        & p {
            @media screen and (max-width: 430px) {
                //position: relative;
                //word-break: break-all;
                //word-wrap: break-word;
                //overflow: hidden;
            }
        }
        @media screen and (max-width: 430px) {
            max-width: 90vw;
            overflow: hidden;
        }
        &:hover {
            text-decoration: underline;
        }
        &-checked {
            font-weight: 400;
        }
    }
    &-remove {
        color: darkred;
        margin-left: 20px;
        margin-right: 20px;
        &:hover {
           text-decoration: underline;
        }
    }
}
.empty-notifications {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    min-width: 400px;
    min-height: 50px;
    overflow: hidden;
}

.user {
    &-lnk {
        color: blue;
        text-decoration: underline;
    }
}

.sickInput {
    padding: 10px 90% 10px 5px;
    border-radius: 10px;
    outline: none;
    width: 100%;
    border: 1px solid grey;
}
.days-count-warn {
    margin-top: 10px;
}

.pin-button {
  position: relative;
  display: inline-block; 
}

.pins-menu {
  min-width: 300px;
  &-wrapper {
    border-bottom: 1px solid lightgray;
    padding: 5px;
  }
}

.pin-item {
  display: flex;
  justify-content: space-between;
  &-name {
    display: flex;
     img {
      width: 15px;
      margin-left: 15px;
    }
  }
  a {
    &:hover {
      text-decoration: underline;
    }
  }
}

.pin-close {
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.lang-wrap {
  margin-top: 5px;
  margin-right: 20px;
}

.no-pins {
  color: grey;
  font-weight: 400;
}
</style>
